
    import { defineComponent } from 'vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import phoneValidateService from '@/apps/shared/services/phone-service';
    import DiscountRangeService from '@/apps/shared/services/getDiscountRange-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';
    import TitleAndPromotions from '@/apps/shared/components/TitlesAndPromotions.vue';
    import ExtendedContactInfo from "@/apps/shared/components/ExtendedContactInfo.vue";

    export default defineComponent({
        name: 'tabOne',
        components: {
            XBreadcrumb,
            TitleAndPromotions,
            ExtendedContactInfo
        },
        data() {
            return {
                titleAndPromotionDetails: {
                    title: "Hogar",
                    subTitle: "Para comenzar, vamos a pedirte algunos datos personales",
                    product: "Hogar",
                    icon: {
                        src: '/Logos/hogarPremium.svg',
                        alt: 'Hogar',
                        title: 'Hogar'
                    },
                    iconPromotion: {
                        src: '/Logos/hogarPremium.svg',
                        alt: 'hogar-promo',
                        title: 'hogar-promo'
                    }
                } as TitleAndPromotionsDetails,
                validatePhone: false,
                firstName: null,
                lastName: null,
                telephone: '',
                areaCode: '',
                email: null,
                changeTitlePromotions: false,
                messageErrorPhone: null,
                messageErrorAreaCode: null,
                messageErrorDigits: null,
                containDiscountRange: null,
                validDigits: null,
                discountRate: null,
                breadcrumItems: [
                    { text: 'Inicio', path: '/hogar-premium' },
                ],
                leadId: null,
                referente: null,
                medium: null,
                pas: null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Hogar Premium';
                const actualPath = '/hogar-premium';
                const actualStep = 'tab-one';
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, null);
                    const title = this.$store.getters.getWebSaleData?.pageCustomization?.navbar?.title ?? '';
                    this.pas = title === defaultTitle ? null : title;
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultFamilyCombinedGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            comenzar() {
                const extendedContactInfoData = this.$refs.extendedContactInfoRef.getFormData();
                NF.Validation.Form.validate('#formData');
                this.validatePhone = false;
                const { firstName, lastName, email, telephone, areaCode, validTelephone, validEmail } = extendedContactInfoData;
                this.firstName = firstName;
                this.lastName = lastName;
                this.email = email;
                this.telephone = telephone;
                this.areaCode = areaCode;
                this.validatePhone = validTelephone;
                const validName = firstName && firstName.trim() !== "";
                const validLastName = lastName && lastName.trim() !== "";
                const validateEmail = validEmail;
                if (validName && validLastName && this.validatePhone && validateEmail) {
                    NF.UI.Page.block();
                    return new Promise<any>(async (resolve) => {
                        CRMCotizadorWebService.CreateOrEditLead(this.leadId, this.email, location.href, this.areaCode, this.telephone, 927, false, "1", null, this.lastName, this.name).then((response) => {
                            resolve(true);
                            sessionStorage.setItem("LeadId", JSON.stringify(response));

                            const eventData = {
                                'pas': this.pas,
                                'email': this.email,
                                'product': 'hogarPremium',
                                'event': 'cotizador-hogar-premium-datos-personales',
                                'referente': this.referente,
                                'medio': this.medium
                            };

                            window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                            window.globalThis.dataLayer.push(eventData);

                            const customWindow = window as typeof window & {
                                _qsie?: Array<typeof eventData>;
                            };

                            customWindow._qsie ??= [];
                            customWindow._qsie.push(eventData);

                            sessionStorage.setItem("TabOneWelcome", JSON.stringify({
                                firstName: this.firstName,
                                lastName: this.lastName,
                                areaCode: this.areaCode,
                                telephone: this.telephone,
                                email: this.email
                            }));
                            this.$router.push({
                                name: 'tabTwoFamilyCombinedPremium',
                            })
                        });
                    })
                } else {
                    const eventData = {
                        'pas': this.pas,
                        'email': this.email,
                        'product': 'hogarPremium',
                        'event': 'errorUsuario',
                        'paso': 'cotizador-hogar-premium-datos-personales',
                        'referente': this.referente,
                        'medio': this.medium
                    };

                    window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                    window.globalThis.dataLayer.push(eventData);

                    const customWindow = window as typeof window & {
                        _qsie?: Array<typeof eventData>;
                    };

                    customWindow._qsie ??= [];
                    customWindow._qsie.push(eventData);
                }
            },
            async getFamilyCombinedDiscountRange() {
                NF.UI.Page.block();
                await DiscountRangeService.getFamilyCombinedDiscountRange().then((response) => {
                    this.containDiscountRange = response.length > 0;
                    if (this.containDiscountRange) {
                        this.responseDiscountRange = response;
                        this.discountRate = this.responseDiscountRange[0].discountMaxValue;
                        this.fechaPromotions = new Date();
                        var FechaInicioEvento = new Date(Date.parse("05/15/2025"));
                        var FechaFinEvento = new Date(Date.parse("05/18/2025"));
                        this.changeTitlePromotions = (this.fechaPromotions >= FechaInicioEvento && this.fechaPromotions <= FechaFinEvento);

                        this.containDiscountRange = true;
                        this.discountRate = response[0].discountMaxValue;
                        this.sendDataDiscount = {
                            discountRate: this.discountRate,
                            containDiscountRange: this.containDiscountRange,
                            changeTitlePromotions: this.changeTitlePromotions,
                        };
                        this.$refs.titlesAndPromotions.setDiscountData(this.sendDataDiscount);
                    }
                }).finally(() => {
                    NF.UI.Page.unblock();
                });
            },
            getInitData() {
                this.leadId = JSON.parse(sessionStorage.getItem("LeadId"));
                var validBack = sessionStorage.getItem("pressBack");
                if (validBack) {
                    sessionStorage.removeItem("pressBack");
                    var dataTomador = sessionStorage.getItem("TabOneWelcome");
                    if (dataTomador != null) {
                        this.dataTomadorJson = JSON.parse(dataTomador!);
                        this.$refs.extendedContactInfoRef.setFormData(this.dataTomadorJson);
                    }
                }
                else {
                    const eventData = {
                        'pas': this.pas,
                        'email': this.email,
                        'product': 'hogarPremium',
                        'event': 'cotizador-hogar-premium-view',
                        'referente': this.referente,
                        'medio': this.medium
                    };

                    window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                    window.globalThis.dataLayer.push(eventData);

                    const customWindow = window as typeof window & {
                        _qsie?: Array<typeof eventData>;
                    };

                    customWindow._qsie ??= [];
                    customWindow._qsie.push(eventData);

                    sessionStorage.clear();
                    sessionStorage.setItem("Referente", this.referente);
                    sessionStorage.setItem("Medium", this.medium);
                    sessionStorage.setItem("ExitOrContinueModal", "true");
                }
            }
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
                var medium = sessionStorage.getItem("Medium");
                medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

                await this.pageCustomization();

                const parallelPromises = [
                    this.updateByProductGoogleAnalytics(),
                    this.getFamilyCombinedDiscountRange()
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

                this.getInitData();

            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
